import React from 'react'
import { useI18n } from '../../i18n'
import styles from '../../styles/components/assets/AssetsInformationSystems.module.scss'
import {
  type InformationSystemPanelContext,
  CONTEXT_NAV_ITEMS,
  contextNavLabel,
  switchContextKind,
} from './informationSystemPanelContext'
import { featureFlags } from '../../config/featureFlags'

interface Props {
  panelContext: InformationSystemPanelContext
  onContextChange: (ctx: InformationSystemPanelContext) => void
}

export default function ContextNav({ panelContext, onContextChange }: Props) {
  const { t } = useI18n()
  const navItems = CONTEXT_NAV_ITEMS.filter((k) => {
    if (k === 'fullPassport') return false
    if (k === 'executive' && !featureFlags.ENTERPRISE_OPERATIONAL_UX_V1) return false
    return true
  })

  return (
    <nav className={styles.contextNav} aria-label={t('assets.panelContext.nav', 'Context navigation')}>
      <div className={styles.contextNavScroll}>
        {navItems.map((kind) => (
          <button
            key={kind}
            type="button"
            className={`${styles.contextNavChip} ${panelContext.kind === kind ? styles.contextNavChipActive : ''}`.trim()}
            onClick={() => onContextChange(switchContextKind(panelContext, kind))}
          >
            {contextNavLabel(kind, t)}
          </button>
        ))}
      </div>
    </nav>
  )
}
